import { useLazyQuery } from '@apollo/client';
import { MetadataTableName } from '@bechtel/sr-types';
import {
  GET_CABLE_BY_ID,
  GET_CABLE_CODE_BY_ID,
  GET_COLOR_CODE_BY_ID,
  GET_EQUIPMENT_BY_ID,
  GET_EQUIPMENT_CODE_BY_ID,
  GET_FIRE_AREA_BY_ID,
  GET_JUMPER_BY_ID,
  GET_RACEWAY_BY_ID,
  GET_RACEWAY_CODE_BY_ID,
  GET_REEL_BY_ID,
} from '~/gql';

export const getCommodityQuery = (name: MetadataTableName) => {
  switch (name) {
    case MetadataTableName.EQUIPMENT:
      return GET_EQUIPMENT_BY_ID;
    case MetadataTableName.EQUIPMENT_CODE:
      return GET_EQUIPMENT_CODE_BY_ID;
    case MetadataTableName.CABLE:
      return GET_CABLE_BY_ID;
    case MetadataTableName.RACEWAY:
      return GET_RACEWAY_BY_ID;
    case MetadataTableName.JUMPER:
      return GET_JUMPER_BY_ID;
    case MetadataTableName.CABLE_CODE:
      return GET_CABLE_CODE_BY_ID;
    case MetadataTableName.RACEWAY_CODE:
      return GET_RACEWAY_CODE_BY_ID;
    case MetadataTableName.COLOR_CODE:
      return GET_COLOR_CODE_BY_ID;
    case MetadataTableName.REEL:
      return GET_REEL_BY_ID;
    case MetadataTableName.FIRE_AREA:
      return GET_FIRE_AREA_BY_ID;
    default:
      return GET_EQUIPMENT_BY_ID;
  }
};

export function useGetCommodityByIdQuery(name: MetadataTableName, fetchFromNetwork?: boolean) {
  const response = useLazyQuery(
    getCommodityQuery(name),
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
